import { useTranslation } from 'react-i18next';
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";

const NoticiasHome = ({ noticias, ruta, lang, elementosweb, config }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.bhh-noticia', noticias.length);

    return (
        noticias.length > 0 ?
            <div className="fons potblur bhh-noticias">
                <div className="bhh-noticias__layout">
                    <div className="bhh-noticias__intro">
                        <span className="bhh-eyebrow">{t("Diario de viaje")}</span>
                        <h2>{elementosweb.cabecera_buscador[lang]}</h2>
                        <p>{t("Eventos, guias, trucos, noticias y más...")}</p>
                        <a href={"/" + preidioma + t("blog")} className="bhh-noticias__link">
                            {t("Más propuestas")} <i className="fa-solid fa-arrow-right"></i>
                        </a>
                        <div className="bhh-noticias__nav">
                            <button
                                type="button"
                                disabled={navState.atStart}
                                onClick={() => scrollByCard(-1)}
                                className="bhh-destacados__prev"
                                aria-label={t("Anterior")}
                            >
                                <i className="fa-solid fa-arrow-left"></i>
                            </button>
                            <button
                                type="button"
                                disabled={navState.atEnd}
                                onClick={() => scrollByCard(1)}
                                className="bhh-destacados__next"
                                aria-label={t("Siguiente")}
                            >
                                <i className="fa-solid fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>

                    <div className="bhh-noticias__track" ref={trackRef}>
                        {noticias.map((noticia, index) => {
                            const href = "/" + preidioma + t("blog") + "/" + noticia.laurl;
                            const imagen = noticia.imagen != ""
                                ? ruta + "/blog/" + noticia.id + "/" + noticia.imagen
                                : "/images/web/bedloop-nofoto.png";
                            return (
                                <div className="bhh-noticia" key={index}>
                                    <div className="bhh-property__card">
                                        <a href={href} className="bhh-property__media bhh-noticia__media" style={{ "--bhh-noticia-fons": "url(\"" + imagen + "\")" }}>
                                            <img className="destacats-imatge-propietat" alt={noticia.eltitulo} title={noticia.eltitulo} src={imagen} loading="lazy" />
                                        </a>
                                        <div className="bhh-property__body">
                                            <span className="destacats-data">
                                                <i className="fa-solid fa-calendar"></i> {noticia.fecha_publica}
                                            </span>
                                            <h3 className="bhh-property__title"><a href={href}>{noticia.eltitulo}</a></h3>
                                            <div className="bhh-property__desc" dangerouslySetInnerHTML={{ __html: noticia.ladesc }}></div>
                                            <a className="bhh-property__cta" href={href}>
                                                {t("leer más")}
                                                <i className="fa-solid fa-plus"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            :
            <></>
    )
}

export default NoticiasHome;
